import React from "react";

export const TriaLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="triaGradBrand" x1="32" y1="4" x2="32" y2="60" gradientUnits="userSpaceOnUse">
        <stop stopColor="#8fd0ff" />
        <stop offset="0.55" stopColor="#3b82f6" />
        <stop offset="1" stopColor="#1e4fb0" />
      </linearGradient>
    </defs>
    <g stroke="url(#triaGradBrand)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M29 10 L32 6 L35 10" />
      <path d="M17 15 L20 11 L23 15" />
      <path d="M41 15 L44 11 L47 15" />
      <path d="M32 6 V23" />
      <path d="M20 11 V22" />
      <path d="M44 11 V22" />
      <path d="M19 23 Q20 24 24 24 H40 Q44 24 45 23" />
      <path d="M32 23 V55" />
      <path d="M27 55 H37" />
    </g>
  </svg>
);

export function TriaFooter() {
  return (
    <footer className="border-t border-border px-4 sm:px-6 lg:px-8 py-6" data-testid="app-footer">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <TriaLogo className="h-7 w-7" />
          <div className="leading-tight">
            <div className="font-display font-extrabold tracking-[0.22em] text-foreground text-sm">TRIA</div>
            <div className="text-[11px] text-muted-foreground">Inteligência financeira para varejo e brechós</div>
          </div>
        </div>
        <div className="text-xs text-muted-foreground">Developed by Sapientia Consultores Associados</div>
      </div>
    </footer>
  );
}
